import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
    trackCreateBookingCancel,
    trackCreateBookingStepChange,
} from '../actions/analytics';

import CreateStepper from '../components/create/CreateStepper';

import {
    setNewBookingInitialState,
    setAvailablePlant,
    setNewBookingPlant,
    createBooking,
} from '../actions/newBooking';

class CreateStepperContainer extends Component {
    constructor(props) {
        super(props);

        this.props.setNewBookingInitialState();
    }

    render() {
        return (
            <CreateStepper { ...this.props } />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        newBooking: state.newBooking,
        person: state.environment.person,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingInitialState,
        setAvailablePlant,
        setNewBookingPlant,
        createBooking,
        trackCreateBookingCancel,
        trackCreateBookingStepChange,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateStepperContainer);



// WEBPACK FOOTER //
// ./scripts/containers/CreateStepperContainer.jsx